import * as allTypes from '../mutation-type';
import { getRecomGroupe } from '@/api/recom';
import { urlToDataUrl } from '@/api/recom';
import { getIconPdvData } from '@/services/gestionIconMarker/iconColorGetter';

function initialState() {
  return {
    recoms: [],
    pointDeVentes: [],
    panneaux: [],
  };
}

async function generateIconPdv(url) {
  const dataUrl = (await urlToDataUrl(url)).data;
  return (await getIconPdvData(dataUrl)).icon;
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_RECOMS_GROUPE(state, recoms) {
    state.recoms = recoms;
  },
  SET_PDV_GROUPE(state, pointDeVentes) {
    state.pointDeVentes = pointDeVentes;
  },
  SET_PANNEAUX_GROUPE(state, panneaux) {
    state.panneaux = panneaux;
  },
};

const actions = {
  getRecomsGroupe: async ({ commit, dispatch }) => {
    let idGroupe = 'aab576d6-6099-4dbd-a28b-e7f63cf00aa7';
    if (process.env.NODE_ENV === 'production') {
      idGroupe = '#{ID_GROUPE}#';
    }
    const { data } = await getRecomGroupe(idGroupe);
    commit('SET_RECOMS_GROUPE', data);
    dispatch('genererPanneaux', { data });
    await dispatch('genererPointDeVente', { data });
  },
  genererPointDeVente: async ({ commit }, payload) => {
    const pdv = payload.data
      .map(recom => ({
        adresse: recom.data.pointDeVentes[0].adresse,
        srcImg: recom.data.pointDeVentes[0].srcImg,
        icon: recom.data.pointDeVentes[0].icon,
        idEnseigne: recom.data.pointDeVentes[0].idEnseigne,
        previewLink: recom.previewLink
      }));
    const imgs = [... new Set(pdv.map(el => el.srcImg))].filter(el => el.includes('https://'));
    let req = [];
    let urls = imgs.map(el => ({ url: el}));
    urls.forEach(el => {
      req.push(generateIconPdv(el.url))
    });
    let res = await Promise.all(req);
    urls.forEach((el, i) => {
      el.img = res[i];
    });
    req = res = [];
    pdv.forEach(el => {
      const url = urls.find(val => val.url === el.srcImg);
      if (url) el.icon = url.img;
    });
    commit('SET_PDV_GROUPE', pdv);
  },
  genererPanneaux: ({ commit }, payload) => {
    const pdvs = payload.data
      .map(recom => recom.data.pointDeVentes[0]);
    pdvs.forEach(pdv => {
      pdv.panneaux.forEach(pann => {
        pann.idEnseigne = pdv.idEnseigne;
      });
    });
    const panneaux = pdvs.map(pdv => pdv.panneaux).flat()
      .map(pann => ({
        adresse: pann.adresse,
        couleur: pann.categorie.couleur,
        azimut: pann.azimut,
        idEnseigne: pann.idEnseigne
      })).filter(pann => pann.adresse.coordonnees.lng > -5 && pann.adresse.coordonnees.lng < 12 && pann.adresse.coordonnees.lat > 40);
    commit('SET_PANNEAUX_GROUPE', panneaux);
  },
};

const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
